var script = {
  name: 'Tooltip'
};

export { script as default };
//# sourceMappingURL=tooltip.vue2.js.map
